<template>
    <div v-if="user">
        <b-modal v-model="modalShow"
                 size="lg"
                 :title="`専属${$locale.patient}編集`"
                 ok-title="保存"
                 ok-variant="yokumiru-orange"
                 cancel-title="キャンセル"
                 cancel-variant="yokumiru-gray"
                 @ok="handleOk"
                 @cancel="close"
                 @hidden="close">

            <form @submit.stop.prevent="editExclusiveUser">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="mb-3">
                            <label for="edit_timezone">タイムゾーン設定</label>
                            <select v-model="user.timezone"
                                    id="edit_timezone"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.timezone }">

                                <option value="">選択してください</option>
                                <option v-for="timezone in timezones" :value="timezone.key">
                                    {{ timezone.value }}
                                </option>
                            </select>

                            <div v-if="errors.timezone"
                                 class="invalid-feedback d-block">
                                {{ errors.timezone[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_user_category_id">{{ $locale.patient }}区分</label>
                            <select v-model="user.user_category_id"
                                    id="edit_user_category_id"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.user_category_id }">

                                <option value="">選択してください</option>
                                <option v-for="user_category in user_categories" :value="user_category.id">
                                    {{ user_category.name }}
                                </option>
                            </select>

                            <div v-if="errors.user_category_id"
                                 class="invalid-feedback d-block">
                                {{ errors.user_category_id[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_user_code">所属コード</label>

                            <input v-model="user.user_code"
                                   id="edit_user_code"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.user_code }"
                                   type="text">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.user_code">
                                {{ errors.user_code[0]}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_last_name">姓</label>

                            <input v-model="user.last_name"
                                   id="edit_last_name"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.last_name }"
                                   type="text"
                                   placeholder="姓">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.last_name">
                                {{ errors.last_name[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_first_name">名</label>

                            <input v-model="user.first_name"
                                   id="edit_first_name"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.first_name }"
                                   type="text"
                                   placeholder="名">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.first_name">
                                {{ errors.first_name[0]}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_last_name_kana">セイ</label>

                            <input v-model="user.last_name_kana"
                                   id="edit_last_name_kana"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.last_name_kana }"
                                   type="text"
                                   placeholder="セイ">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.last_name_kana">
                                {{errors.last_name_kana[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_first_name_kana">メイ</label>

                            <input v-model="user.first_name_kana"
                                   id="edit_first_name_kana"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.first_name_kana }"
                                   type="text"
                                   placeholder="メイ">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.first_name_kana">
                                {{errors.first_name_kana[0]}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-3">
                        <div class="mb-3">
                            <label>住所（国内/海外）</label>
                            <div class="form-group mt-1">
                                <div class="form-check form-check-inline">
                                    <input v-model="countrySelect"
                                           type="radio"
                                           id="edit_country_domestic"
                                           class="form-check-input"
                                           @change="countrySelectChange()"
                                           value="国内">
                                    <label class="form-check-label"
                                           for="edit_country_domestic">国内
                                    </label>
                                </div>

                                <div class="form-check form-check-inline">
                                    <input v-model="countrySelect"
                                           type="radio"
                                           id="edit_country_overseas"
                                           class="form-check-input"
                                           @change="countrySelectChange()"
                                           value="海外">
                                    <label class="form-check-label"
                                           for="edit_country_overseas">海外
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-9" v-if="countrySelect === '海外'">
                        <div class="mb-3">
                            <label for="country">Country</label>

                            <div class="input-group">
                                <input v-model="user.country"
                                       type="text"
                                       id="country"
                                       class="form-control"
                                       :class="{ 'is-invalid' : errors.country }"
                                       placeholder="Country">

                                <div v-if="errors.country"
                                     class="invalid-feedback d-block">
                                    {{ errors.country[0] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="mb-3">
                            <label for="edit_postcode" v-if="countrySelect === '国内'">郵便番号</label>
                            <label for="edit_postcode" v-if="countrySelect === '海外'">Zip</label>

                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">〒</span>
                                </div>

                                <input v-model="user.postcode"
                                       @change="changePostcode"
                                       type="text"
                                       id="edit_postcode"
                                       class="form-control"
                                       :class="{ 'is-invalid' : errors.postcode }"
                                       placeholder="000-1111">

                                <div v-if="errors.postcode"
                                     class="invalid-feedback d-block">
                                    {{ errors.postcode[0] }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="mb-3">
                            <label for="edit_prefecture" v-if="countrySelect === '国内'">都道府県</label>
                            <label for="edit_prefecture" v-if="countrySelect === '海外'">State/Province/Region</label>

                            <select v-model="user.prefecture"
                                    id="edit_prefecture"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.prefecture }"
                                    v-if="countrySelect === '国内'">

                                <option value="">選択してください</option>
                                <option v-for="pref in prefmap" :value="pref">
                                    {{ pref }}
                                </option>
                            </select>
                            <input v-model="user.prefecture"
                                   type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid' : errors.prefecture }"
                                   placeholder="State/Province/Region"
                                   v-if="countrySelect === '海外'">

                            <div v-if="errors.prefecture"
                                 class="invalid-feedback d-block">
                                {{ errors.prefecture[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="mb-3">
                            <label v-if="countrySelect === '国内'">市区町村・番地</label>
                            <label v-if="countrySelect === '海外'">City</label>

                            <input v-model="user.address"
                                   v-if="countrySelect === '国内'"
                                   type="text"
                                   id="edit_address"
                                   class="form-control"
                                   :class="{ 'is-invalid' : errors.address }"
                                   placeholder="市区町村・番地">
                            <input v-model="user.address"
                                   v-if="countrySelect === '海外'"
                                   type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid' : errors.address }"
                                   placeholder="City">
                            <div v-if="errors.address"
                                 class="invalid-feedback d-block">
                                {{ errors.address[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="mb-3">
                            <label v-if="countrySelect === '国内'">建物名など</label>
                            <label v-if="countrySelect === '海外'">Address Line</label>

                            <input v-model="user.building"
                                   v-if="countrySelect === '国内'"
                                   type="text"
                                   id="edit_building"
                                   class="form-control"
                                   :class="{ 'is-invalid' : errors.building }"
                                   placeholder="建物名など">
                            <input v-model="user.building"
                                   v-if="countrySelect === '海外'"
                                   type="text"
                                   class="form-control"
                                   :class="{ 'is-invalid' : errors.building }"
                                   placeholder="Address Line">
                            <div v-if="errors.building"
                                 class="invalid-feedback d-block">
                                {{ errors.building[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="tel">電話番号<span class="small">（滞在している国の国際番号）</span></label>
                            <vue-tel-input
                                v-model="user.tel"
                                id="tel"
                                name="tel"
                                :class="{ 'is-invalid' : errors.tel || telObj.valid === false }"
                                placeholder="000-1111-2222"
                                valid-characters-only
                                default-country="JP"
                                @validate="onValidateTel">
                            </vue-tel-input>
                            <div v-if="errors.tel" class="invalid-feedback d-block">{{ errors.tel[0] }}</div>
                            <div v-if="telObj.valid === false" class="invalid-feedback d-block">電話番号を正しく入力してください</div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="edit_email">メールアドレス</label>

                            <input v-model="user.email"
                                   id="edit_email"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.email }"
                                   type="text"
                                   placeholder="メールアドレス">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.email">
                                {{ errors.email[0]}}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="edit_password">パスワード</label>

                            <input v-model="user.password"
                                   id="edit_password"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.password }"
                                   type="password"
                                   placeholder="パスワード">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.password">
                                {{ errors.password[0]}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-6">
                        <div class="form-group m-form__group">
                            <label for="edit_birth_year">生年月日</label>

                            <div class="d-flex align-items-center">
                                <select class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }"
                                        v-model="birth_year"
                                        id="edit_birth_year"
                                        name="birth_year">

                                    <option v-for="n in rangeYear"
                                            :value="n + yearBase">
                                        {{ n + yearBase }}
                                    </option>
                                </select>
                                <div class="ml-2 mr-2">年</div>

                                <select class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }"
                                        v-model="birth_month"
                                        id="edit_birth_month"
                                        name="birth_month">

                                    <option v-for="n in 12"
                                            :value="n">
                                        {{ n }}
                                    </option>
                                </select>
                                <div class="ml-2 mr-2">月</div>

                                <select class="form-control"
                                        :class="{ 'is-invalid' : errors.birthday }"
                                        v-model="birth_day"
                                        id="edit_birth_day"
                                        name="birth_day">

                                    <option v-for="n in rangeDate"
                                            :value="n">
                                        {{ n }}
                                    </option>
                                </select>
                                <div class="ml-2">日</div>
                            </div>

                            <div class="invalid-feedback d-block mt-1" v-if="errors.birthday">
                                {{ errors.birthday[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-6">
                        <div class="m-form__group form-group">
                            <label class="form-control-label">性別</label>

                            <div class="m-radio-inline">
                                <label class="m-radio mr-2 pt-1">
                                    <input v-model="user.sex"
                                           type="radio"
                                           name="sex"
                                           value="0">
                                    <span>男</span>
                                </label>

                                <label class="m-radio mr-2 pt-1">
                                    <input v-model="user.sex"
                                           type="radio"
                                           name="sex"
                                           value="1">
                                    <span>女</span>
                                </label>
                            </div>

                            <div class="invalid-feedback d-block mt-1" v-if="errors.sex">
                                {{ errors.sex[0] }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="edit_height">身長</label>

                            <input v-model="user.height"
                                   id="edit_height"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.height }"
                                   type="text"
                                   placeholder="身長">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.height">
                                {{ errors.height[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="edit_weight">体重</label>

                            <input v-model="user.weight"
                                   id="edit_weight"
                                   class="form-control m-input"
                                   :class="{ 'is-invalid' : errors.weight }"
                                   type="text"
                                   placeholder="体重">

                            <div class="invalid-feedback d-block mt-1" v-if="errors.weight">
                                {{ errors.weight[0] }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-sm-4">
                        <div class="form-group m-form__group">
                            <label for="edit_blood">血液型</label>

                            <select v-model="user.blood"
                                    id="edit_blood"
                                    class="form-control"
                                    :class="{ 'is-invalid' : errors.blood }">

                                <option :value="null">選択してください</option>
                                <option value="A">A型</option>
                                <option value="B">B型</option>
                                <option value="O">O型</option>
                                <option value="AB">AB型</option>
                            </select>

                            <div v-if="errors.blood"
                                 class="invalid-feedback d-block">
                                {{ errors.blood[0] }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-sm-8">
                        <label>{{ $locale.patient }}メモ
                            <img v-if="!isEdit"
                                 class="icon-pencil mb-2"
                                 src="/images/common/icon_pencil.svg"
                                 @click="editMemo"/>
                        </label>
                        <div v-if="isEdit" class="small">
                            <textarea v-model="doctor_memo"
                                      class="form-control small"
                                      :class="{ 'is-invalid' : errors.doctor_memo }"
                                      rows="6"
                                      @blur="updateDoctorMemo"
                                      placeholder="メモを入力"
                                      id="doctor_memo_area">
                            </textarea>
                            <div v-if="errors.doctor_memo"
                                 class="invalid-feedback d-block">
                                {{ errors.doctor_memo[0] }}
                            </div>
                        </div>
                        <div v-else class="small">
                            <textarea v-model="doctor_memo"
                                      class="form-control small"
                                      rows="6"
                                      disabled>
                            </textarea>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <hr>
                        <ul class="mb-0">
                            <li class="small mb-2">パスワードはアルファベット（小・大文字を両方含む）と数字の組み合わせ8～32文字で設定してください</li>
                            <li class="mb-0">
                                <span class="small">パスワードとして使用可能な記号は</span>
                                <span>&nbsp;!&nbsp;$&nbsp;%&nbsp;+&nbsp;/&nbsp;=&nbsp;?&nbsp;[&nbsp;]&nbsp;@&nbsp;</span>
                                <span class="small">です</span>
                            </li>
                            <li class="small mb-2">パスワードを変更しない場合は空のままにしてください。</li>
                        </ul>
                    </div>
                </div>
            </form>

            <div slot="modal-footer" class="w-100" :class="{ 'u-loader u-loader--sm' : inProgress }">
                <button class="btn btn-yokumiru-orange float-right" @click="handleOk">保存</button>
                <button class="btn btn-yokumiru-gray float-right mr-2" @click="close">キャンセル</button>
            </div>
        </b-modal>

        <transition name="fade">
            <div v-show="saved" class="alert alert-success">専属{{ $locale.patient }}の登録内容を変更しました。</div>
        </transition>

        <transition name="fade">
            <div v-show="failed" class="alert alert-danger">設定内容に不備があります。ご確認ください。</div>
        </transition>
    </div>
</template>

<script>
    import moment from 'moment-timezone';
    import constants from '../../../constants';

    export default {
        data: function () {
            return {
                inProgress :false,
                isEdit:false,
                doctor_memo: null,
                modalShow: false,
                doctorId: null,
                user: null,
                user_password: null,
                user_categories: [],
                birth_year: 1900,
                birth_month: 1,
                birth_day: 1,
                yearBase: 1899,
                yearTo: moment().year(),
                errors: [],
                saved: false,
                failed: false,
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                timezones: [],
                countrySelect: null,
                telObj: {},
            };
        },

        created: function() {
            bus.$on( 'open-modal-exclusive-user-edit', this.open )
            this.timezone()
            this.user_category()
        },

        beforeDestroy: function() {
            bus.$off( 'open-modal-exclusive-user-edit' )
        },

        methods: {
            onValidateTel: function (object) {
                if (object.number.input) {
                    this.telObj = object
                }
                else {
                    this.telObj = {
                        number: { e164: null, national: null },
                        valid: true,
                        regionCode: null,
                    }
                }
            },

            countrySelectChange: function() {
                if (this.countrySelect === '海外') {
                    this.user.country = ''
                    this.user.prefecture = ''
                }
                else{
                    this.user.country = '日本'
                    this.user.prefecture = ''
                }
            },

            fetchDoctorMemo: function(){
                axios.get(`${constants.doctor.doctor_memo.endpoint.base}/${this.doctorId}/${this.user.id}`)
                    .then((response) => {
                        this.errors = {};
                        this.doctor_memo = response.data.doctor_memo;
                    })
                    .catch(({response}) => {
                        if (response.data.errors) {
                            this.errors = response.data.errors;
                        }
                    });
            },

            editMemo: function(){
                this.isEdit = !this.isEdit;
                this.$nextTick(() => document.getElementById('doctor_memo_area').focus());
            },
            /**
             * 患者メモ保存FC
             *
             * @param {object} item
             */
            updateDoctorMemo: function () {
                const data = {
                    doctor_memo: this.doctor_memo,
                };

                axios.put(`${constants.doctor.doctor_memo.endpoint.base}/${this.doctorId}/${this.user.id}`, data)
                    .then(() => {
                        this.errors = {};
                        this.isEdit = false;
                    })
                    .catch(({response}) => {
                        if (response.data.errors) {
                            this.errors = response.data.errors;
                        }
                    });
            },
            /**
             * モーダルを表示
             */
            open: function(user, doctorId ) {
                this.doctorId = doctorId
                this.user = { ...user }
                this.user.password = null
                this.birth_year = moment(user.birthday).year()
                this.birth_month = moment(user.birthday).month() + 1
                this.birth_day = moment(user.birthday).date()
                this.countrySelect = this.user.country === '日本' ? '国内' : '海外'

                if (Number(this.doctorId) > 0) {
                    this.fetchDoctorMemo()
                }

                this.modalShow = true
            },

            /**
             * モーダルを閉じる
             */
            close: function() {
                this.modalShow = false
                this.user = null
            },

            /**
             * 保存ボタン押下時
             *
             * @param {object} e
             * @return {void}
             */
            handleOk(e) {
                e.preventDefault()
                this.editExclusiveUser()
            },

            /**
             * 専属患者の編集保存
             *
             * @return {void}
             */
            editExclusiveUser: async function() {
                if (this.inProgress) return
                this.inProgress = true

                this.user.birthday = this.birth_year.toString() + '-' +
                    this.birth_month.toString().padStart( 2, '0' ) + '-' +
                    this.birth_day.toString().padStart( 2, '0' )

                this.user.tel = this.telObj.number.e164
                this.user.tel_national = this.telObj.number.national
                this.user.tel_region = this.telObj.regionCode

                if ( this.user_password ) {
                    this.user.password = this.user_password
                }

                await axios.post(`/doctor/api/${this.doctorId}/users/exclusive/edit/${this.user.id}`, this.user)
                    .then( () => {
                        bus.$emit('alert-success', `${ this.$locale.patient }の登録内容を変更しました。`)
                        bus.$emit('fetch-users')
                        this.user = null
                        this.errors = []
                        this.modalShow = false
                        bus.$emit( 'refresh-exclusive-users' )
                    } )
                    .catch( ({response}) => {
                        bus.$emit('alert-danger')
                        if ( response.data.errors ) {
                            this.errors = response.data.errors
                        }
                    } )

                this.inProgress = false
            },

            /**
             * 郵便番号入力時
             */
            changePostcode: function() {
                let postcode = this.user.postcode;
                postcode = postcode.replace( '-', '' );

                axios.get( `${constants.doctor.zip.endpoint.base}?postcode=${postcode}` )
                    .then( ({data}) => {
                        try {
                            let newPrefecture = data.data[0].ja.prefecture;
                            let newAddress = data.data[0].ja.address1 + data.data[0].ja.address2 + data.data[0].ja.address3+ data.data[0].ja.address4;
                            this.user.prefecture = newPrefecture;
                            this.user.address = newAddress;
                        }
                        catch (e) {
                            this.user.prefecture = "";
                            this.user.address = "";
                            console.log( '__YokumiruAPI__ : 住所情報の取得に失敗しました。' );
                        }
                    } );
            },

            timezone: function() {
                axios.get( constants.doctor.users.endpoint.timezone )
                    .then( ({data}) => {
                        this.timezones = data.data
                    } );
            },

            user_category: function () {
                axios.get(constants.doctor.users.endpoint.user_categories)
                    .then(({data}) => {
                        this.user_categories = data
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            },
        },

        computed: {
            rangeYear: function() {
                return this.yearTo - this.yearBase;
            },

            rangeDate: function() {
                const current =
                    this.birth_year.toString() + '-' +
                    this.birth_month.toString().padStart( 2, '0' ) + '-' + '01';

                return moment( current ).endOf( 'month' ).date();
            },
        },
    };
</script>

<style scoped lang="scss">
    .alert {
        position: fixed;
        left: 50%;
        top: 20px;
        z-index: 9999;
        width: 80vw;
        transform: translate( -50%, 0 );
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    #edit_birth_year{
        min-width:70px;
    }
    #edit_birth_month{
        min-width:45px;
    }
    #edit_birth_day{
        min-width:45px;
    }
    .icon-pencil {
        position: relative;
        top: 2px;
        width: 14px;
        margin-left: 3px;
        cursor: pointer;
    }
</style>
